import { useState } from "react";
import { useForm } from "react-hook-form";

const PaymentPage = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [selectedMethod, setSelectedMethod] = useState("card"); // Default method

  const onSubmit = (data) => {
    alert("Payment Successful!");
  };

  return (
    <div className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-semibold mb-4">Payment Details</h2>
      <p className="text-gray-600 text-sm mb-4">
        Complete your purchase by providing your payment details.
      </p>

      {/* Payment Form */}
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Email Address<span className="text-red-500"> *</span>
          </label>
          <input
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                message: "Enter a valid email address",
              },
            })}
            className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
          />
          {errors.email && <p className="text-red-500 text-sm">{errors.email.message}</p>}
        </div>

        {/* Payment Method Selection */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Select Payment Method<span className="text-red-500"> *</span>
          </label>
          <div className="flex space-x-4">
            <button
              type="button"
              className={`w-1/2 p-2 border rounded-md ${selectedMethod === "card" ? "border-blue-500 bg-blue-100" : "border-gray-300"}`}
              onClick={() => setSelectedMethod("card")}
            >
              Debit/Credit Card
            </button>

            <button
              type="button"
              className={`w-1/2 p-2 border rounded-md ${selectedMethod === "mpesa" ? "border-green-500 bg-green-100" : "border-gray-300"}`}
              onClick={() => setSelectedMethod("mpesa")}
            >
              M-Pesa
            </button>
          </div>
        </div>

        {/* Card Payment Fields */}
        {selectedMethod === "card" && (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Cardholder Name<span className="text-red-500"> *</span>
              </label>
              <input
                {...register("cardName", { required: "Cardholder name is required" })}
                className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
              />
              {errors.cardName && <p className="text-red-500 text-sm">{errors.cardName.message}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Card Number<span className="text-red-500"> *</span>
              </label>
              <input
                {...register("cardNumber", {
                  required: "Card number is required",
                  pattern: {
                    value: /^[0-9]{16}$/,
                    message: "Enter a valid 16-digit card number",
                  },
                })}
                className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
              />
              {errors.cardNumber && (
                <p className="text-red-500 text-sm">{errors.cardNumber.message}</p>
              )}
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Expiry Date (MM/YY)<span className="text-red-500"> *</span>
                </label>
                <input
                  {...register("expiryDate", {
                    required: "Expiry date is required",
                    pattern: {
                      value: /^(0[1-9]|1[0-2])\/([0-9]{2})$/,
                      message: "Enter a valid MM/YY format",
                    },
                  })}
                  className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
                />
                {errors.expiryDate && (
                  <p className="text-red-500 text-sm">{errors.expiryDate.message}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  CVV<span className="text-red-500"> *</span>
                </label>
                <input
                  {...register("cvv", {
                    required: "CVV is required",
                    pattern: {
                      value: /^[0-9]{3}$/,
                      message: "Enter a valid 3-digit CVV",
                    },
                  })}
                  className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
                />
                {errors.cvv && <p className="text-red-500 text-sm">{errors.cvv.message}</p>}
              </div>
            </div>
          </>
        )}

        {/* M-Pesa Payment Fields */}
        {selectedMethod === "mpesa" && (
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Phone Number<span className="text-red-500"> *</span>
            </label>
            <input
              {...register("phoneNumber", {
                required: "Phone number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Enter a valid 10-digit phone number",
                },
              })}
              className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
            />
            {errors.phoneNumber && (
              <p className="text-red-500 text-sm">{errors.phoneNumber.message}</p>
            )}
          </div>
        )}

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-blue-600 text-white p-3 rounded-md hover:bg-blue-700 transition"
        >
          Make Payment
        </button>
      </form>
    </div>
  );
};

export default PaymentPage;
